import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const api = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const useRecentlyViewed = () => {
  const { token } = useContext(AuthContext);
  return useQuery(
    "recentlyViewed",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/customer/recently-viewed`, api(token));
      return res.data.items;
    },
    { enabled: !!token }
  );
};

export const useRecordRecentlyViewed = () => {
  const { token } = useContext(AuthContext);
  const qc = useQueryClient();
  return useMutation(
    (productId) =>
      axios.post(`${process.env.REACT_APP_SERVER_URL}/customer/recently-viewed/${productId}`, {}, api(token)),
    { onSuccess: () => qc.invalidateQueries("recentlyViewed") }
  );
};
